module.exports = __webpack_public_path__ + "img/16.74cb9e3a.jpg";